import React from "react";
import {Card, CardBody} from "reactstrap";
import TransactionsListHeader from "../../molecules/transactionsListHeader/transactionsListHeader";
import TransactionsDataList from "../../organisms/transactionsDataList/transactionsDataList";
import "./listTransactionsTemplate.sass";
import {observer} from "mobx-react-lite";

export interface IListTransactionsTemplate {
  /**
   * Flag denoting if transactions are loading.
   */
  isTransactionsListLoading: boolean;
}

const ListTransactionsTemplate: React.FC<IListTransactionsTemplate> = ({
  isTransactionsListLoading
}) => {
  return (
    <div
      className="list-transactions-template"
      data-testid="listTransactionsTemplate"
    >
      <Card>
        <TransactionsListHeader />
        <CardBody>
          {isTransactionsListLoading ? null : <TransactionsDataList />}
        </CardBody>
      </Card>
    </div>
  );
};

export default observer(ListTransactionsTemplate);
